"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var StepContentTheme = function StepContentTheme(colors) {
  return {
    styleOverrides: {
      root: {
        fontFamily: 'Barlow',
        fontSize: '0.75rem',
        lineHeight: 1.2,
        letterSpacing: 0,
        color: colors.lynch,
        borderLeft: "5px solid ".concat(colors.lynch),
        marginLeft: '6px',
        paddingLeft: '13px',
        marginTop: '-1px',
        paddingTop: '5px'
      },
      last: {
        border: 'none',
        marginLeft: '11px'
      }
    }
  };
};

var _default = StepContentTheme;
exports["default"] = _default;